import { render, staticRenderFns } from "./orders-container.vue?vue&type=template&id=76715e18&scoped=true&lang=pug"
import script from "./orders-container.js?vue&type=script&lang=js&external"
export * from "./orders-container.js?vue&type=script&lang=js&external"
import style0 from "./orders-container.vue?vue&type=style&index=0&id=76715e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76715e18",
  null
  
)

export default component.exports